import { renderSlot as _renderSlot, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, vShow as _vShow, withDirectives as _withDirectives, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-cb67db6e"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["id"]
const _hoisted_2 = ["aria-selected"]
const _hoisted_3 = { class: "megamenu-location-group__title" }
const _hoisted_4 = {
  key: 0,
  class: "plus-minus"
}
const _hoisted_5 = {
  role: "tabpanel",
  class: "megamenu-location-group__content"
}
const _hoisted_6 = { class: "megamenu-location-group__content-inner" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Icon = _resolveComponent("Icon")!

  return (_openBlock(), _createElementBlock("div", {
    id: _ctx.id,
    class: _normalizeClass(["megamenu-location-group__tab", { 'megamenu-location-group__tab--open': _ctx.isOpen }]),
    role: "tablist"
  }, [
    _createElementVNode("button", {
      class: "megamenu-location-group__button",
      "aria-selected": _ctx.isOpen,
      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('clickTab', $event))),
      type: "button",
      role: "tab"
    }, [
      _createElementVNode("span", _hoisted_3, [
        _renderSlot(_ctx.$slots, "title")
      ]),
      (!_ctx.icon)
        ? (_openBlock(), _createElementBlock("span", _hoisted_4))
        : (_openBlock(), _createBlock(_component_Icon, {
            key: 1,
            class: "-mr-1 text-white",
            icon: _ctx.icon,
            size: 25
          }, null, 8, ["icon"]))
    ], 8, _hoisted_2),
    _createVNode(_Transition, { name: "expand" }, {
      default: _withCtx(() => [
        _withDirectives(_createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _renderSlot(_ctx.$slots, "default")
          ])
        ], 512), [
          [_vShow, _ctx.isOpen]
        ])
      ]),
      _: 3
    })
  ], 10, _hoisted_1))
}